<template>
    <div class="scroll-left w-100" ref="wrapper">
        <div class="scrollme" ref="inner" :class="{ start: start }" :style="style">
            <div class="scrollme-item" v-for="item in items">
                {{ item.text }}
            </div>
        </div>
    </div>
</template>
<script>
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';

export default {
    props: {
        announcements: {},
        speed: {
            default: 1,
        },
    },
    data: () => ({
        start: false,
        duration: 0,
        style: false,
        items: [],
    }),
    mounted() {
        const self = this;

        this.$nextTick(() => {
            let adjustedDuration = this.setDuration();

            forEach(this.items, (item) => {
                if (item.iterations) {
                    setTimeout(function () {
                        self.start = false;
                        self.items = filter(self.items, (removeItem) => {
                            return removeItem.text !== item.text;
                        });
                        self.setDuration();
                        self.start = true;
                    }, adjustedDuration * item.iterations * 1000 * 0.99);
                }
            });

            this.start = true;
        });
    },
    methods: {
        setDuration() {
            let insideWidth = this.$refs.inner.clientWidth;
            let duration = 0.011028558161133 * insideWidth - 0.96122591130718;
            let adjustedDuration = duration - (duration * this.speed - duration);
            this.style = `-moz-animation-duration: ${adjustedDuration}s; -webkit-animation-duration: ${adjustedDuration}s; animation-duration: ${adjustedDuration}s;`;

            return adjustedDuration;
        },
    },
    watch: {
        announcements: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.items = [];
                forEach(newVal, (announcement) => {
                    this.items.push(announcement);
                });
            },
        },
    },
};
</script>
